/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { CreatePaymentRequest } from './CreatePaymentRequest';
import { useSelector, useDispatch } from 'react-redux';
import { listPaymentRequests } from 'redux/actions/PaymentRequestAction';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { deletePaymentRequest, getPaymentRequest } from 'services/billingServices';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
import _ from 'lodash';
import { RecordPayment } from './RecordPayment';
import useSpinner from 'hooks/useSpinner';
import { Reminders } from './Reminders';
import { SendNotificationMail } from './SendNotificationMail';
import { useLocation } from 'react-router-dom';
import { dollarFormat, paginationDropdownOptions } from 'utils/utils';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { Tooltip } from 'primereact/tooltip';
import { handleDateTimeOffset } from 'utils/utility_functions/timezone';
import { UserDetailsContext } from 'context/userDetailsContext';
import constants from 'constants/index';
import { handlePageNumberInPagination } from 'common/pagination';
import moment from 'moment';
import TextSnippetWrapper from 'components/TextSnippetWrapper';
import GlobalTooltip from 'components/GlobalTooltip';
import ResizableDataTable from 'components/ResizableDataTable/ResizableDataTable';
import { setTimezoneWithoutAlteringTime } from 'utils/utility_functions/timezone';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { getLocalStorageParseItem, removeLocalStorageItem } from 'utils/localStorageUtils';
import { useConfidoPaymentLinkMutation } from 'hooks/mutations/useConfidoPaymentLinkMutation';
import { useWebSocket } from 'context/WebSocketConnectionContext';

export const PaymentRequests = (props) => {
  const { isFromCaseSpecificModule, getCaseDetails, getTimeEntrySummarty, isFromGlobalBilling, handlePaymentRequestTableRedirection } =
    props || {};
  const { subscribe, unsubscribe } = useWebSocket();

  const [showModal, setShowModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState();
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [searchKey, setSearchKey] = useState('');
  const [dateFilter, setDateFilter] = useState(null);
  const [showRecordModal, setShowRecordModal] = useState(false);
  const [confirmSendMail, setConfirmSendMail] = useState(false);
  const paymentRequests = useSelector((state) => state.paymentRequests.payment_requests);
  const isLoading = useSelector((state) => state.paymentRequests.isLoading);
  const next_Token = paymentRequests.next_token;
  const transition_Token = paymentRequests.transition_token;

  const dispatch = useDispatch();
  const { addToast } = useToast();
  const [spinner, showSpinner, hideSpinner] = useSpinner(true);
  const [showReminder, setShowReminder] = useState(false);
  const location = useLocation();
  const userContext = useContext(UserDetailsContext);
  const [selectedPractice, setSelectedPractice] = useState(null);
  const [pageLimit, setPageLimit] = useState(getPageLimit() ?? 10);
  const [isForward, setIsForward] = useState(true);

  const { generatePaymentLink, isLoading: isConfidoLinkLoading } = useConfidoPaymentLinkMutation({
    onSuccess: (res) => {
      const link = res?.data;
      if (link) {
        window.open(link, '_blank', 'noopener,noreferrer');
      }
    },
    onError: (err) => {
      addToast(
        false,
        toastConstant.toasterType.ERROR,
        toastConstant.api.FAILED,
        err?.response?.data?.error || toastConstant.message.SOMETHING_WENT_WRONG
      );
    },
  });

  const practiceData = useSelector((state) => state.practiceArea.practiceAreaList['practice-area']);
  const [practiceAreaOptions, setPracticeAreaOptions] = useState([]);

  function getPageLimit() {
    if (props.isLeadSpecific && userContext) {
      return userContext?.firmDetails?.pagination_preference?.leads?.billings?.payments_request;
    } else if (isFromCaseSpecificModule && userContext) {
      return userContext?.firmDetails?.pagination_preference?.case?.billings?.payments_request;
    } else if (userContext) {
      return userContext?.firmDetails?.pagination_preference?.billings?.payments_request;
    }
  }

  function getFilePathForPagination() {
    if (props.isLeadSpecific && userContext) {
      return { module: 'leads', subModule: 'billings', listName: 'payments_request' };
    } else if (isFromCaseSpecificModule && userContext) {
      return { module: 'case', subModule: 'billings', listName: 'payments_request' };
    } else {
      return { module: 'billings', subModule: '', listName: 'payments_request' };
    }
  }

  useEffect(() => {
    if (practiceData && practiceData.length) {
      let practice_options = practiceData.map((val) => {
        return {
          label: val.practice_area_name,
          value: val.practice_area_id,
        };
      });
      setPracticeAreaOptions(practice_options);
    } else {
      setPracticeAreaOptions([]);
    }
  }, [practiceData]);

  useEffect(() => {
    loadPaymentRequests(getPageLimit() ?? 10, '');
    if (localStorage.getItem('redirectToRequestPayment')) {
      setShowModal(true);
      localStorage.removeItem('redirectToRequestPayment');
    }
  }, []);

  // Subscribe to confido payment events to reload the payment requests list when a confido payment is created or updated
  useEffect(() => {
    const handleConfidoPayment = () => {
      loadPaymentRequests(getPageLimit() ?? 10, '');
    };
    subscribe('confido_payment', handleConfidoPayment);
    return () => unsubscribe('confido_payment', handleConfidoPayment);
  }, [subscribe, unsubscribe]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const paymentRequestSk = queryParams.get('payment_request_sk');

    if (paymentRequestSk && !selectedRequest) {
      const decodedPaymentRequestSk = decodeURIComponent(paymentRequestSk);

      getPaymentRequest(decodedPaymentRequestSk)
        .then((response) => {
          if (response?.data) {
            setSelectedRequest(response.data);
            setShowModal(true);
          }
        })
        .catch((error) => {
          console.error('Error fetching payment request:', error);
        });
    } else if (!paymentRequestSk && !selectedRequest && localStorage.getItem('viewPaymentRequest')) {
      let paymentRequestDetails = location?.state || getLocalStorageParseItem('stateData');

      if (paymentRequestDetails) {
        setSelectedRequest(paymentRequestDetails);
        setShowModal(true);
        removeLocalStorageItem('stateData');
        removeLocalStorageItem('viewPaymentRequest');
      }
    }
  }, [location, localStorage, window.localStorage]);

  useEffect(() => {
    if (isLoading) {
      showSpinner();
    } else {
      hideSpinner();
    }
  }, [isLoading]);

  const pickExtractedDate = (dateArray) => {
    return {
      payment_date_lower: dateArray?.[0]
        ? setTimezoneWithoutAlteringTime(moment(dateArray[0]).startOf('day'), userContext?.userDetails.timezone)
        : '',
      payment_date_upper: dateArray?.[0]
        ? setTimezoneWithoutAlteringTime(moment(dateArray[1] ? dateArray[1] : dateArray[0]).endOf('day'), userContext?.userDetails.timezone)
        : '',
    };
  };

  const loadPaymentRequests = (pageLimit = 10, pagination_token = '', pagination_direction = 'forward') => {
    let filters = {
      ...pickExtractedDate(dateFilter),
      payment_request_status: '',
      search_key: searchKey,
      practice_area: selectedPractice,
    };
    if (props.caseView) {
      filters.case_id = props?.caseDetails?.case_id;
    }
    dispatch(listPaymentRequests(filters, pageLimit, pagination_token, pagination_direction));
  };
  const onCreateSuccess = () => {
    setShowModal(false);
    setShowRecordModal(false);
    loadPaymentRequests(getPageLimit() ?? 10, '');
    typeof getTimeEntrySummarty === 'function' && getTimeEntrySummarty();
    typeof getCaseDetails === 'function' && getCaseDetails();
  };

  const idBody = (rowData) => {
    return (
      <React.Fragment>
        <span
          onClick={() => {
            setSelectedRequest({ ...rowData });
            setShowModal(true);
          }}
          className="w-100"
        >
          <span className="p-column-title text-break">ID</span>
          <span className={'text-break text-primary-dark text-decoration-none'} role={'button'} title={rowData.payment_request_number}>
            {rowData.payment_request_number}
          </span>
        </span>
      </React.Fragment>
    );
  };

  const caseBody = (rowData) => {
    const { case_id, is_lead } = rowData;
    const mainModuleName = is_lead ? '/leads' : '/cases';
    let route = case_id ? `${mainModuleName}/${case_id}` : mainModuleName;

    return (
      <React.Fragment>
        <span className="p-column-title text-break">Case</span>
        <Link to={route} className="redirection-link-no-text-transform" title={rowData.case_name ? rowData.case_name : undefined}>
          {rowData.case_name ? rowData.case_name : '-'}
        </Link>
      </React.Fragment>
    );
  };

  const viewBody = (rowData) => {
    let viewed_status = rowData.viewed_status ? rowData.viewed_status : 'Not Viewed';

    if (viewed_status !== 'Not Viewed') {
      viewed_status = handleDateTimeOffset(userContext?.userDetails?.timezone, viewed_status, constants.month_date_year_time_12_format);
    }
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Viewed</span>
        <span className="text-break" title={viewed_status}>
          {viewed_status}
        </span>
      </React.Fragment>
    );
  };

  const statusBody = (rowData) => {
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Status</span>
        <span
          className="text-break"
          title={rowData.payment_request_status ? _.startCase(_.toLower(rowData.payment_request_status)) : undefined}
        >
          {rowData.payment_request_status ? _.startCase(_.toLower(rowData.payment_request_status)) : ''}
        </span>
      </React.Fragment>
    );
  };

  const totalBody = (rowData) => {
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Total</span>
        <span className="text-break" title={dollarFormat(rowData.amount)}>
          {dollarFormat(rowData.amount)}
        </span>
      </React.Fragment>
    );
  };

  const dueBody = (rowData) => {
    const dueAmount = rowData?.due_amount ? dollarFormat(rowData?.due_amount) : dollarFormat(0.0);
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Due</span>
        <span className="text-break" title={dueAmount}>
          {dueAmount}
        </span>
      </React.Fragment>
    );
  };

  const dueTodayBody = (rowData) => {
    if (!rowData?.is_payment_plan) {
      return (
        <React.Fragment>
          <span className="p-column-title text-break">Due Today</span>
          <span className="text-break" title="-">
            -
          </span>
        </React.Fragment>
      );
    }

    const displayAmount =
      rowData?.plan_due_amount !== undefined && rowData?.plan_due_amount !== null
        ? dollarFormat(rowData?.plan_due_amount)
        : dollarFormat(rowData?.due_amount);
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Due Today</span>
        <span className="text-break" title={displayAmount}>
          {displayAmount}
        </span>
      </React.Fragment>
    );
  };

  const sentBody = (rowData) => {
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Sent</span>
        <span
          className="text-break"
          title={handleDateTimeOffset(userContext?.userDetails?.timezone, rowData.payment_request_date, constants.month_date_year_format)}
        >
          {handleDateTimeOffset(userContext?.userDetails?.timezone, rowData.payment_request_date, constants.month_date_year_format)}
        </span>
      </React.Fragment>
    );
  };

  const actionBody = (rowData) => {
    let due_amount = rowData?.due_amount;
    due_amount = due_amount ? parseInt(due_amount) : 0;
    return (
      <React.Fragment>
        <div className="text-nowrap w-100">
          <span className="p-column-title text-break">Action</span>
          {due_amount > 0 && (
            <span
              role="button"
              onClick={(e) => {
                setSelectedRequest({ ...rowData });
                setConfirmSendMail(true);
              }}
            >
              <GlobalTooltip tooltip="Payment Request Reminder">
                <i className="icon-send-form"></i>
              </GlobalTooltip>
            </span>
          )}

          {due_amount > 0 && (
            <span role="button">
              <GlobalTooltip tooltip="Record Payment" className={'ms-2'}>
                <i
                  className="icon-radio"
                  onClick={(e) => {
                    setSelectedRequest({ ...rowData });
                    setShowRecordModal(true);
                  }}
                />
              </GlobalTooltip>
            </span>
          )}
          {due_amount > 0 && userContext?.userDetails?.is_confido_connected && (
            <span role="button">
              <GlobalTooltip
                tooltip={
                  rowData?.confido_bank_account_id
                    ? 'Accept Payment'
                    : 'No Confido Bank Account mapped with this payment request deposit account'
                }
                className={'ms-2'}
              >
                <i
                  className={`bi bi-credit-card-2-back${isConfidoLinkLoading || !rowData?.confido_bank_account_id ? ' p-disabled' : ''}`}
                  style={{ color: '#7f8f9f' }}
                  onClick={() => generatePaymentLink({ data: {}, contactId: rowData?.billing_contact_id, sk: rowData?.sk })}
                />
              </GlobalTooltip>
            </span>
          )}

          {due_amount > 0 && (
            <span
              role="button"
              onClick={(e) => {
                setSelectedRequest({ ...rowData });
                setShowReminder(true);
              }}
            >
              <GlobalTooltip tooltip="Reminder" className={'ms-2'}>
                <i className="icon-notification" />
              </GlobalTooltip>
            </span>
          )}

          {rowData && !rowData.is_payment_record && (
            <span role="button">
              <GlobalTooltip tooltip="Delete" className={'ms-2'}>
                <i
                  className="icon-delete"
                  onClick={(e) => {
                    setSelectedRequest({ ...rowData });
                    setConfirmDelete(true);
                  }}
                />
              </GlobalTooltip>
            </span>
          )}
        </div>
      </React.Fragment>
    );
  };

  const deleteRequest = () => {
    if (selectedRequest) {
      setConfirmDelete(false);
      deletePaymentRequest(selectedRequest.sk, props.isLeadSpecific ? props?.isLeadSpecific : selectedRequest?.is_lead)
        .then(() => {
          addToast(
            false,
            toastConstant.toasterType.SUCCESS,
            toastConstant.api.SUCCESS,
            toastConstant.message.DELETE_PAYMENT_REQUEST_SUCCESS
          );
          loadPaymentRequests(getPageLimit() ?? 10, '');
        })
        .catch((err) => {
          addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.DELETE_PAYMENT_REQUEST_FAILED);
        });
    }
  };

  const onSearchKeyDown = (e) => {
    let code = e.keyCode ? e.keyCode : e.which;
    if (code === 13) {
      dispatch(
        listPaymentRequests(
          {
            ...pickExtractedDate(dateFilter),
            payment_request_status: '',
            search_key: searchKey,
            practice_area: selectedPractice,
            case_id: props?.caseView ? props?.caseDetails?.case_id : '',
          },
          getPageLimit() ?? 10
        )
      );
    }
  };

  const onChangeSearch = (e) => {
    let value = e.target.value;
    setSearchKey(value);
    if (!value) {
      dispatch(
        listPaymentRequests(
          {
            ...pickExtractedDate(dateFilter),
            payment_request_status: '',
            search_key: '',
            practice_area: selectedPractice,
            case_id: props?.caseView ? props?.caseDetails?.case_id : '',
          },
          getPageLimit() ?? 10
        )
      );
    }
  };

  const onChangeCalendar = (e) => {
    setDateFilter(e.value);
    dispatch(
      listPaymentRequests(
        {
          ...pickExtractedDate(e.value),
          payment_request_status: '',
          search_key: searchKey,
          practice_area: selectedPractice,
          case_id: props?.caseView ? props?.caseDetails?.case_id : '',
        },
        getPageLimit() ?? 10
      )
    );
  };

  const onChangePractice = (e) => {
    setSelectedPractice([...e.value]);
    dispatch(
      listPaymentRequests(
        {
          ...pickExtractedDate(dateFilter),
          payment_request_status: '',
          search_key: searchKey,
          practice_area: [...e.value],
          case_id: props?.caseView ? props?.caseDetails?.case_id : '',
        },
        getPageLimit() ?? 10
      )
    );
  };

  const refreshCase = () => {
    setSearchKey('');
    setSelectedPractice();
    setDateFilter('');
    setSelectedRequest();
    dispatch(
      listPaymentRequests(
        {
          payment_date_upper: '',
          payment_date_lower: '',
          payment_request_status: '',
          search_key: '',
          practice_area: '',
          case_id: props?.caseView ? props?.caseDetails?.case_id : '',
        },
        getPageLimit() ?? 10
      )
    );
  };
  const paginatorTemplate = {
    layout: 'RowsPerPageDropdown PrevPageLink NextPageLink',
    RowsPerPageDropdown: (options) => {
      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--black-500)', userSelect: 'none' }}>
            Item Per Page
          </span>
          <Dropdown value={options.value} options={paginationDropdownOptions} onChange={onPageChange} />
        </React.Fragment>
      );
    },
    NextPageLink: ({ iconClassName }) => {
      return (
        <Button
          onClick={onNextPageClick}
          disabled={next_Token === null && isForward}
          className={'p-paginator-next p-paginator-element p-link'}
          icon={iconClassName}
        />
      );
    },
    PrevPageLink: ({ iconClassName }) => {
      return (
        <Button
          onClick={onPrevPageClick}
          disabled={transition_Token === null || (transition_Token && next_Token === null && !isForward)}
          className={'p-paginator-next p-paginator-element p-link'}
          icon={iconClassName}
        />
      );
    },
  };

  const onNextPageClick = () => {
    loadPaymentRequests(pageLimit, !isForward ? transition_Token : next_Token, 'forward');
    setIsForward(true);
  };
  const onPrevPageClick = () => {
    loadPaymentRequests(pageLimit, isForward ? transition_Token : next_Token, 'reverse');
    setIsForward(false);
    //setPreviousToken(transition_Token);
  };
  const onPageChange = (event) => {
    setPageLimit(event.value);
    let path = getFilePathForPagination();
    handlePageNumberInPagination(userContext, path?.module, path?.subModule, path?.listName, event.value);
    loadPaymentRequests(event.value, '', 'forward');
  };

  const nextDueDateBody = (rowData) => {
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Next Due Date</span>
        <span
          className="text-break"
          title={
            rowData?.amount?.toString() === rowData?.paid_amount?.toString() || rowData?.payment_request_status === 'PAID'
              ? undefined
              : handleDateTimeOffset(userContext?.userDetails?.timezone, rowData?.due_date, constants.month_date_year_format)
          }
        >
          {rowData?.amount?.toString() === rowData?.paid_amount?.toString() || rowData?.payment_request_status === 'PAID'
            ? '-'
            : handleDateTimeOffset(userContext?.userDetails?.timezone, rowData?.due_date, constants.month_date_year_format)}
        </span>
      </React.Fragment>
    );
  };

  return (
    <div>
      {spinner}
      {showModal && (
        <CreatePaymentRequest
          modal={showModal}
          setModal={(value) => {
            setShowModal(value);
            if (!value) {
              setSelectedRequest(null);

              const queryParams = new URLSearchParams(location.search);
              const hadPaymentRequestSk = queryParams.has('payment_request_sk');

              if (hadPaymentRequestSk) {
                const cleanUrl = window.location.href.split('?')[0];
                window.history.replaceState({}, '', cleanUrl);
              }
            }
          }}
          onCreateSuccess={onCreateSuccess}
          selectedRequest={selectedRequest}
          caseView={props.caseView}
          isLeadSpecific={props?.isLeadSpecific}
          caseDetails={props.caseDetails}
          billingSummary={props.billingSummary}
          getCaseDetails={getCaseDetails}
        />
      )}
      <ConfirmDialog
        header="Confirm Delete"
        message={' Do you want to delete this payment request?'}
        visible={confirmDelete}
        rejectClassName="p-button-secondary outline"
        icon="pi pi-exclamation-triangle"
        className="confirm-delete-popup"
        accept={() => {
          deleteRequest();
          typeof getTimeEntrySummarty === 'function' && getTimeEntrySummarty();
        }}
        reject={() => {
          setConfirmDelete(false);
          setSelectedRequest();
        }}
        onHide={() => {
          setConfirmDelete(false);
          setSelectedRequest();
        }}
      />

      {showRecordModal ? (
        <RecordPayment
          show={showRecordModal}
          onHide={() => {
            setShowRecordModal(false);
          }}
          selectedRequest={selectedRequest}
          onSuccess={onCreateSuccess}
          isLeadSpecific={props?.isLeadSpecific}
          caseDetails={props?.caseDetails}
        />
      ) : null}

      {showReminder && (
        <Reminders
          show
          onHide={() => {
            setShowReminder(false);
          }}
          selectedRequest={selectedRequest}
          onSuccess={onCreateSuccess}
          isLeadSpecific={props?.isLeadSpecific}
        />
      )}
      <SendNotificationMail
        show={confirmSendMail}
        onHide={() => {
          setConfirmSendMail(false);
        }}
        selectedRequest={selectedRequest}
        isLeadSpecific={props?.isLeadSpecific}
      />
      <div className="row">
        <div className="col-12">
          <div className="d-flex align-items-center  mb-3">
            <Button
              label="Request Payment"
              icon="pi pi-plus"
              className="p-button p-button-primary ms-auto"
              onClick={() => {
                setSelectedRequest();
                setShowModal(true);
              }}
            ></Button>
          </div>
        </div>
      </div>

      <div className="">
        <div className="d-flex flex-wrap align-items-center filter-wrap p-lg-0 p-2 mb-3 w-100 align-items-center justify-content-between">
          <div className="p-2 filter-wraper">
            <span className="p-input-icon-left input-shadow">
              <i className="icon-search F-size16"></i>
              <TextSnippetWrapper
                type="text"
                placeholder="Search"
                onChange={(e) => {
                  onChangeSearch(e);
                }}
                value={searchKey}
                onKeyDown={onSearchKeyDown}
                className="p-inputtext p-component input-search"
                autoComplete="off"
              />
            </span>
          </div>
          <div className="d-flex flex-wrap align-items-center p-2 filter-wraper gap-2">
            <label className="text-bold black-600 p-0 filter-label">Filters:</label>
            <div className="d-flex flex-column filter-wraper">
              <Calendar
                className="input-shadow filter-calender"
                selectionMode="range"
                id="icon"
                value={dateFilter}
                onChange={(e) => {
                  onChangeCalendar(e);
                }}
                showIcon
                placeholder="Date"
              />
            </div>
            {!isFromCaseSpecificModule && !props?.isLeadSpecific && (
              <div className="d-flex flex-column  filter-wraper">
                <MultiSelect
                  value={selectedPractice}
                  options={practiceAreaOptions}
                  onChange={onChangePractice}
                  placeholder="Practice Area"
                  maxSelectedLabels={1}
                  display="chip"
                  filter
                  className="input-shadow w-100 F-size14 input-width"
                />
              </div>
            )}

            <div className="d-flex flex-column ">
              <div className="pointer ms-0">
                <i className="fas fa-sync-alt" onClick={refreshCase}></i>
                <Tooltip content="Reset Filter" position="top" target=".fa-sync-alt" showDelay={500} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="datatable-responsive bg-white shadow-middle mb-3">
        <ResizableDataTable
          value={paymentRequests?.payment_request || []}
          className="p-datatable-responsive"
          paginator
          paginatorTemplate={paginatorTemplate}
          rows={pageLimit}
          storageKey="payment_request-list"
          columns={[
            { field: 'payment_request_number', header: 'ID', body: idBody, bodyClassName: 'ellipsis-text' },
            { field: 'case_name', header: 'Case', body: caseBody, bodyClassName: 'ellipsis-text', hidden: !isFromGlobalBilling },
            { field: 'viewed_status', header: 'Viewed', body: viewBody, bodyClassName: 'ellipsis-text' },
            { field: 'payment_request_status', header: 'Status', body: statusBody, bodyClassName: 'ellipsis-text' },
            { field: 'amount', header: 'Total', body: totalBody, bodyClassName: 'ellipsis-text' },
            { field: 'due_amount', header: 'Due', body: dueBody, bodyClassName: 'ellipsis-text' },
            { field: 'due_amount', header: 'Due Today', body: dueTodayBody, bodyClassName: 'ellipsis-text' },
            { field: 'due_date', header: 'Next Due Date', body: nextDueDateBody, bodyClassName: 'ellipsis-text' },
            { field: 'payment_request_date', header: 'Sent', body: sentBody, bodyClassName: 'ellipsis-text' },
            {
              field: 'action',
              header: 'Action',
              body: actionBody,
              bodyClassName: 'text-nowrap',
              fixed: true,
              width: '130px',
              resizable: false,
            },
          ]}
        />
        <Tooltip target={'#payReq'} position={'top'} showDelay={500} className="case-tooltip mb-3">
          Payment Request
        </Tooltip>
        <Tooltip target={'#recordPay'} position={'top'} showDelay={500} className="case-tooltip mb-3">
          Record Payment
        </Tooltip>
        <Tooltip target={'#reminder'} position={'top'} showDelay={500} className="case-tooltip mb-3">
          Reminder
        </Tooltip>
        <Tooltip target={'#delete'} position={'top'} showDelay={500} className="case-tooltip mb-3">
          Delete
        </Tooltip>
      </div>
    </div>
  );
};
